export enum LostItemsFormActionType {
  MARK_AS_LOST = 'MARK_AS_LOST',
  MARK_AS_ACTIVE = 'MARK_AS_ACTIVE',
}
